<template>
  <v-app class="subordinates-workload-layout-page">
    <HeaderToolbar
      :fixed="true"
      :extended="$vuetify.breakpoint.mdAndDown"
      :extensionHeight="'48px'"
    >
      <HeaderActions slot="actions" />
      <v-toolbar-title
        v-if="$vuetify.breakpoint.mdAndDown"
        slot="header-extension"
        class="po-toolbar-title white--text ma-0"
      >
        <v-layout align-center justify-start wrap>
          <v-flex
            xs12
            class="text-truncate"
          >
            <v-btn
              icon
              @click="toggleSideBarVisibility"
            >
              <v-icon>view_list</v-icon>
            </v-btn>
            <span>{{ 'Workload' }}</span>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
    </HeaderToolbar>
    <router-view name="sidebar"></router-view>
    <v-content>
      <v-container pa-0 fluid fill-height>
        <slot />
      </v-container>
      <SnackbarNotification />
    </v-content>
    <SatFooter />
  </v-app>
</template>

<script>
import SnackbarNotification from '@/components/common/SnackbarNotification.vue';
import SatFooter from '@/components/common/Footer.vue';
import HeaderToolbar from '@/components/common/HeaderToolbar.vue';
import HeaderActions from '@/components/common/HeaderActions.vue';

import SubordinatesWorkloadConstants from '@/store/modules/subordinatesWorkload/constants';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    SnackbarNotification,
    SatFooter,
    HeaderToolbar,
    HeaderActions,
  },
  computed: {
    ...mapState({
      showSideBar: state => state.subordinatesWorkload.showSideBar,
    }),
  },
  methods: {
    toggleSideBarVisibility() {
      this.updateSideBarVisibility(!this.showSideBar);
    },
    ...mapActions('subordinatesWorkload', {
      updateSideBarVisibility: SubordinatesWorkloadConstants.actionTypes.updateSideBarVisibility,
    }),
  },
};
</script>

<style lang="scss">
  .subordinates-workload-layout-page{
    main{
      background: #f2f2f2;
    }
  }
</style>
